import { ILogger } from "./ILogger";

export class ConsoleLogger implements ILogger {
    public debug(message: string): void {
        console.log(`[Debug] ${message}`);
    }
    public info(message: string): void {
        console.log(message);
    }
    public warn(message: string): void {
        console.warn(message);
    }
    public event(message: string, attachments: Record<string, string>): void {
        if (attachments == null) {
            console.log(`[Event] ${message}`);
        }
        else {
            let attachmentsStr: string;
            try {
                attachmentsStr = JSON.stringify(attachments);
            }
            catch(e: unknown) {
                console.error("Failed to parse attachments: ", attachments, "\nreason: ", e);
            }
            console.log(`[Event] ${message}, attachments: ${attachmentsStr == null ? "Failed to parse" : attachmentsStr}`);
        }
    }

    public error(message?: string): void
    public error(exception?: unknown): void
    public error(message?: string, exception?: unknown): void {
        if (message == null && exception == null) {
            console.error("Unknown error. No data provided");
        }
        else if (message == null) {
            console.error(exception);
        }
        else if (exception == null) {
            console.error(message);
        }
        else {
            console.error(message, exception);
        }
    }

}